module.exports = __webpack_public_path__ + "static/media/95.93f1ed85.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/95.jpg
// module id = 1027
// module chunks = 0